<template>
  <v-select
    v-model="selected"
    :items="items"
    :hide-details="hideDetails"
    :placeholder="placeholder"
    :rules="_rules"
    class="select-box-container"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Object],
      default: undefined
    },
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(val) {
        return this.$emit('input', val)
      }
    },
    _rules() {
      const results = this.rules || []
      if (this.required) {
        results.push((value) => !!value || '必須の項目です')
      }
      return results
    }
  }
}
</script>

<style lang="scss" scoped>
.select-box-container::v-deep {
  .v-input__slot {
    padding-left: 8px;
    color: #545454;
    font-size: 14px;
    letter-spacing: 0.53px;
  }
}
</style>
